/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import { FormattedMessage, IntlShape } from "react-intl";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Column } from "react-table";

import getLabel from "helpers/getLabel";
import DuplicateShipment from "components/molecules/DuplicateShipment/DuplicateShipment";
import { ReactComponent as GuestAccessIcon } from "assets/images/icons/TopNavIcons/GuestAccess.svg";
import getCommonShipmentColumns from "pages/common/Shipments/ShipmentColumns";
import Cookies from "js-cookie";

const getShipperShipmentColumns = (
  intl: IntlShape,
  canCreateQuote: boolean,
  handleOpenGuestAccessDialog: Function,
  user_type: string | null,
  can_consolidate_orders: boolean,
  can_create_multidrop_quote_requests: boolean,
) => {
  let columns: Column[] = [
    ...getCommonShipmentColumns(intl, user_type, can_consolidate_orders, can_create_multidrop_quote_requests),
    {
      Header: intl.formatMessage({
        id: "general.created",
        defaultMessage: "Created",
      }),
      group: intl.formatMessage({
        id: "columns.basic",
        defaultMessage: "Basic",
      }),
      accessor: "payment_location",
      sortable: true,
      Cell: ({ value, row }: any) => (
        <>
          <p className="mb-0">{value}</p>
          <span className="text-primary">
            {typeof row.original?.created_by === "string" ? (
              row.original?.created_by
            ) : (
              <OverlayTrigger
                placement="top"
                delay={{ show: 50, hide: 50 }}
                overlay={<Tooltip id="button-tooltip">{row.original?.created_by?.email}</Tooltip>}
              >
                <span>{row.original?.created_by?.name}</span>
              </OverlayTrigger>
            )}
          </span>
        </>
      ),
    },
    {
      Header: intl.formatMessage({
        id: "general.provider",
        defaultMessage: "Provider",
      }),
      group: intl.formatMessage({
        id: "columns.basic",
        defaultMessage: "Basic",
      }),
      accessor: "awarded_provider",
      sortable: true,
      Cell: ({ value, row }: any) => `${value || row.original?.off_platform_shipment_provider_name}`,
    },
    {
      Header: intl.formatMessage({ id: "tableHeaders.quotedDeliveryDateTime", defaultMessage: "Quoted delivery date time" }),
      group: intl.formatMessage({
        id: "columns.schedule",
        defaultMessage: "Schedule",
      }),
      accessor: "quoted_delivery_datetime",
      Cell: ({ value, row }: any) => <div>{(!row.original.is_off_platform_shipment ? value : null) || "-"}</div>,
    },
    {
      Header: intl.formatMessage({ id: "tableHeaders.quotedPickupDateTime", defaultMessage: "Quoted pickup date time" }),
      group: intl.formatMessage({
        id: "columns.schedule",
        defaultMessage: "Schedule",
      }),
      accessor: "quoted_pickup_datetime",
      Cell: ({ value, row }: any) => <div>{(!row.original.is_off_platform_shipment ? value : null) || "-"}</div>,
    },
    {
      Header: getLabel("Payment location", "capitalize-first"),
      id: "location",
      group: intl.formatMessage({
        id: "columns.other",
        defaultMessage: "Other",
      }),
      accessor: "payment_location",
      sortable: true,
      Cell: ({ value }) => <div>{value || "-"}</div>,
    },
    {
      Header: getLabel("Custom field 01", "capitalize"),
      group: intl.formatMessage({
        id: "columns.other",
        defaultMessage: "Other",
      }),
      accessor: "custom_field_01",
      Cell: ({ value }) => <div>{value || "-"}</div>,
    },
    {
      Header: getLabel("Custom field 02", "capitalize"),
      group: intl.formatMessage({
        id: "columns.other",
        defaultMessage: "Other",
      }),
      accessor: "custom_field_02",
      Cell: ({ value }) => <div>{value || "-"}</div>,
    },
    {
      Header: getLabel("Custom field 03", "capitalize"),
      group: intl.formatMessage({
        id: "columns.other",
        defaultMessage: "Other",
      }),
      accessor: "custom_field_03",
      Cell: ({ value }) => <div>{value || "-"}</div>,
    },
    {
      Header: intl.formatMessage({
        id: "tableHeaders.originCompany",
        defaultMessage: "Origin company",
      }),
      group: intl.formatMessage({
        id: "columns.other",
        defaultMessage: "Other",
      }),
      accessor: "origin.origin_name",
      Cell: ({ value }) => <div>{value || "-"}</div>,
    },
    {
      Header: intl.formatMessage({
        id: "tableHeaders.destinationCompany",
        defaultMessage: "Destination company",
      }),
      group: intl.formatMessage({
        id: "columns.other",
        defaultMessage: "Other",
      }),
      accessor: "delivery.destination_name",
      Cell: ({ value }) => <div>{value || "-"}</div>,
    },
    {
      Header: "",
      accessor: "shipment_reference",
      group: intl.formatMessage({
        id: "columns.other",
        defaultMessage: "Other",
      }),
      actions: true,
      disableDrag: true,
      Cell: ({ value, row }: any) => {
        const { shipment_reference: shipmentId, is_off_platform_shipment: isOffPlatform } = row.original;
        if (Cookies.get("is_guest") === "true") return null;
        return (
          <div
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 0 }}
              overlay={
                <Tooltip id="button-tooltip">
                  <FormattedMessage id="components.molecules.navigation.guestAccess" defaultMessage="Guest Access" />
                </Tooltip>
              }
            >
              <GuestAccessIcon
                onClick={() => handleOpenGuestAccessDialog(shipmentId)}
                height="18"
                width="18"
                className="mr-2"
              />
            </OverlayTrigger>
            {canCreateQuote && !isOffPlatform && <DuplicateShipment type="shipment" reference={value} />}
          </div>
        );
      },
    },
  ];

  // if no custom label exists for the custom field, remove it from the column list
  if (getLabel("Custom field 01", "capitalize") === "Custom field 01") {
    columns = columns.filter((column) => column.Header !== "Custom field 01");
  }
  if (getLabel("Custom field 02", "capitalize") === "Custom field 02") {
    columns = columns.filter((column) => column.Header !== "Custom field 02");
  }
  if (getLabel("Custom field 03", "capitalize") === "Custom field 03") {
    columns = columns.filter((column) => column.Header !== "Custom field 03");
  }

  return columns;
};

export default getShipperShipmentColumns;
